import { useSelector } from "react-redux";
import { GetResultsResponseType } from "wolf/components/organisms/o-fhw-search/mocks/getResults";
import { apiUrlsSelector } from "../../fhw/selectors";
import { filtersSelector } from "../../filters/selectors";
import { mapSettingsSelector } from "../../map/selectors";
import { searchPartnersApi } from "./searchPartnersApi";

export const usePartnersData = (): GetResultsResponseType => {
	const filters = useSelector(filtersSelector)
	const apiUrls = useSelector(apiUrlsSelector)
	const mapSettings = useSelector(mapSettingsSelector)

	const state = searchPartnersApi.endpoints.getPartners.useQueryState({
		filters,
		endpoint: apiUrls?.getResults,
		mapSettings,
	});
	return state.data?.data;
};

export const useCounterPartnersData = (): {
	count: GetResultsResponseType['count'],
	totalCount: GetResultsResponseType['totalCount'],
} => {
	const filters = useSelector(filtersSelector)
	const apiUrls = useSelector(apiUrlsSelector)
	const mapSettings = useSelector(mapSettingsSelector)

	const state = searchPartnersApi.endpoints.getPartners.useQueryState({
		filters,
		endpoint: apiUrls?.getResults,
		mapSettings
	});
	if (!state.data) return {
		count: 0,
		totalCount: 0
	}

	const totalCount = filters.suggestedInput?.zip ? filters.suggestedInput?.zip : 0;
	return {
		count: state.data.data.count,
		totalCount
	};
};
